// Import React and Hooks
import React from 'react'
// Import Redux
import { Provider } from 'react-redux'
// Import Store
import store from './store'
// Import React Router Dom
import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom'
// Import SCSS
import './sass/main.scss'
// Import Views
import Loader from './components/ui/Loader'
//import Header from './components/layout/Header'
//import Footer from './components/layout/Footer'
import BackgroundVideo from './components/layout/BackgroundVideo'
import Modal from './components/layout/Modal'
import Home from './views/Home'
import Register from './views/Register'
import CreatorOffering from './views/CreatorOffering'
import Offerings from './views/Offerings'
import Terms from './views/Terms'



// Path S3
declare global {
  interface Window {
      assetsURl:string,
      drupalSettings:any,
      openOffering:(id:number) => void,
      startAnimation:() => void
      dataLayer: any
  }
}

window.assetsURl = 'https://mxvictoriaddm.s3.us-east-2.amazonaws.com'

function App() {
  return (
    <Provider store={ store }>
      <Router>
        <div className="container container--general">
          <Loader additionalClass='loader--form' />
          <BackgroundVideo />
          <Modal />
          <Switch>
            <Route path='/cempasuchil/ofrendas' exact component={ Home }/>
            <Route path='/registro' exact component={ Register } />
            <Route path='/cempasuchil/crear-ofrenda' component={ CreatorOffering }/>
            <Route path='/cempasuchil/ofrendas-vivas' component={ Offerings }/>
            <Route path='/terminos-y-condiciones' component={ Terms }/>
          </Switch>
        </div>
      </Router>
    </Provider>
  )
}



export default App
